import React from 'react';

// Formik validation
import { useFormik } from "formik";
import { Button, Container, Form, Modal } from 'reactstrap';
import * as Yup from "yup";

import { BaseCustomButton, BaseCustomModal, GradientDecorationLine, BaseSelectComponent } from '../../../shared';

export const LabOperationTestEditModal = ({ props, setShowModal, showModal, modalHeader, modalRespInfo, rowInfo }) => {

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            statusLaboratory: rowInfo?.statusLaboratory,
        },
        validationSchema: Yup.object({
            statusLaboratory: Yup.string().required("Seleccione un estatus"),
        }),
        onSubmit: (values, { resetForm }) => {
            modalRespInfo(values);
            resetForm();
            setShowModal(false);
        }
    });

    const { className } = props;

    const toggle = () => {
        setShowModal(!showModal);
    }

    const onClosed = () => {
        validation.resetForm();
        setShowModal(false);
    }

    const buttons = (
        <div className="page-title-box d-flex justify-content-end">
            <BaseCustomButton
                color="success"
                outline
                className="me-3 p-2"
                icon="mdi-content-save" 
                label="Guardar"
                onClick={validation.handleSubmit}
            />
        
            <BaseCustomButton
                color="danger"
                outline
                className="me-3 p-2"
                icon="mdi-close-circle"
                label="Cancelar"
                onClick={toggle}
            />
        </div>
    );

    const title = (
        <div className=' d-flex ms-3 p-0'>
            <label className='m-0 p-0'><h4 className='text-primary m-0 ps-4'>{modalHeader}</h4></label>
        </div>
    );

    return (
        <>
           <BaseCustomModal
                title={title}
                isModalOpen={showModal}
                handleCancel={() => {
                    toggle();
                    onClosed();
                }}
                centered
                className={className}
                footer={buttons}
                >
                <GradientDecorationLine />

                <Form
                    className="form-horizontal mt-3 mb-1"
                    onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                    }}
                >
                    <Container fluid className="px-5 pb-3">
                    <div className="w-100 me-3">
                        <label htmlFor="exampleInputEmail1" className="text-primary">
                        Estatus
                        </label>
                        <BaseSelectComponent
                            placeholder="Seleccione un estatus"
                            options={[
                                { value: "Pendiente", label: "Pendiente" },
                                { value: "Rechazado", label: "Rechazado" },
                                { value: "Autorizado", label: "Autorizado" }
                            ]}
                            value={validation.values.statusLaboratory || ''}
                            onChange={(val) => {
                                validation.setFieldValue("statusLaboratory", val);
                            }}
                            onBlur={() => validation.setFieldTouched("statusLaboratory", true)}
                            error={validation.errors.statusLaboratory}
                            touched={validation.errors.statusLaboratory}
                            status={validation.errors.statusLaboratory ? "error" : ''}
                            className="text-primary rounded-3"
                        />
                    </div>
                    </Container>

                    <GradientDecorationLine />
                </Form>
            </BaseCustomModal>
        </>
    )
}